import { NgModule } from '@angular/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { BackofficeLanguage, DICTIONARIES } from './translations';

/**
 * Serves the bundled dictionaries instead of fetching them.
 *
 * ngx-translate expects an Observable, so the objects are handed back
 * immediately. Nothing is ever pending, which is what lets the menu translate
 * its labels synchronously while it is being built.
 */
export class BundledTranslateLoader implements TranslateLoader {
  getTranslation(lang: string): Observable<unknown> {
    return of(DICTIONARIES[lang as BackofficeLanguage] ?? DICTIONARIES.en);
  }
}

@NgModule({
  imports: [
    TranslateModule.forRoot({
      loader: { provide: TranslateLoader, useClass: BundledTranslateLoader },
      defaultLanguage: 'en',
    }),
  ],
  exports: [TranslateModule],
})
export class BackofficeI18nModule {}
